import React from "react";
import { useNavigate } from "react-router-dom";
import parentClasses from "../Buttons.module.scss";
import { BTN_TYPE_SECONDARY_LIGHT } from "../../../constants/buttons";
import * as btnConfig from "../btnsSetup";
import * as routes from "../../../constants/routes";

const ButtonGoPremium = ({
  className = "",
  rounded = null,
  size = null,
  alt = null,
  btnType = BTN_TYPE_SECONDARY_LIGHT,
  title = null,
  style = {},
  text = "Assinar",
}) => {
  const navigate = useNavigate();

  const onClickedControl = () => {
    navigate(routes.R_BUY);
  };

  const btnRoundedClass = rounded ? parentClasses.Rounded : "";
  const _text = <span className={parentClasses.Text}>{text}</span>;

  let btnTypeClass = btnConfig.getBtnTypeClass(btnType);

  let btnSizeClass = btnConfig.getBtnSize(size);

  alt = alt ? alt : title ? title : text;

  return (
    <a
      style={style}
      // href=""
      // target="_self"
      className={`${btnTypeClass} ${btnSizeClass} ${btnRoundedClass}  ${className}`}
      title={title ? title : null}
      alt={alt}
      onClick={() => {
        onClickedControl();
      }}
    >
      {_text}
    </a>
  );
};

export default ButtonGoPremium;
